import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, EyeOff } from "lucide-react";

const ChatFile = ({ f }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    api.get(`/chat/files/${f.id}`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [f.id]);
  if (f.type.startsWith("image/")) {
    return url ? <a href={url} target="_blank" rel="noreferrer"><img data-testid="chat-msg-image" src={url} alt={f.name} className="max-h-60 rounded-lg" /></a>
      : <div className="h-24 w-40 animate-pulse rounded-lg bg-black/20" />;
  }
  return (
    <a data-testid="chat-msg-file" href={url || "#"} download={f.name} className="inline-flex items-center gap-2 rounded-lg bg-black/20 px-3 py-2 text-xs underline">
      <FileText className="h-4 w-4" /> {f.name} · {(f.size / 1024).toFixed(0)} KB
    </a>
  );
};

const hhmm = (iso) => new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
const WHO = { staff: "", ai: "Assistente IA" };

export const ChatMessage = ({ m }) => {
  const mine = m.from !== "visitor";
  const tone = m.from === "ai" ? "bg-violet-500/20 text-violet-50 border border-violet-500/30" : mine ? "bg-sky-600 text-white" : "bg-[#1A2234] text-slate-100";
  return (
    <div data-testid={`chat-msg-${m.from}`} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
      <div className={`max-w-[75%] rounded-2xl px-3.5 py-2 text-sm ${tone} ${mine ? "rounded-br-sm" : "rounded-bl-sm"}`}>
        {mine && <div className="mb-0.5 text-[10px] font-semibold opacity-70">{WHO[m.from] || m.author}</div>}
        {m.file && !m.file.flagged && <ChatFile f={m.file} />}
        {m.file?.flagged && <div data-testid="chat-msg-flagged" className="mb-1 flex h-20 w-48 items-center justify-center gap-2 rounded-lg border border-red-500/40 bg-red-500/10 px-3 text-center text-[11px] font-semibold text-red-300"><EyeOff className="h-4 w-4 shrink-0" />Imagem ocultada ({m.file.flagged})</div>}
        {m.text && <div className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">{m.text}</div>}
        <div className="mt-1 text-right text-[10px] opacity-60">{hhmm(m.at)}</div>
      </div>
    </div>
  );
};
